import { environment } from '@quartz-gov-legacy/environments/environment';

(function () {
    'use strict';

    angular.module('bcmModule')
        .factory('biaResponsibilityService', ['$http', '$q', 'bcmService', function ($http, $q, bcmService) {
            var baseUrl = environment.apiUrl + '/Pilot/api/BIAProfile';

            return {

                // Get BIA Responsibility
                getBIAResponsibility: function (biaProfileId, biaResponsibilityId) {
                    var reqUrl = baseUrl + '/' + biaProfileId + '/Responsibility/' + biaResponsibilityId;

                    return $http
                        .get(reqUrl)
                        .then(function (response) {
                            return mapLookupAttributeValues(response.data);
                        });
                },

                // Get BIA Responsibility Container
                getBIAResponsibilityContainer: function (biaProfileId, biaResponsibilityId) {
                    var reqUrl = baseUrl + '/' + biaProfileId + '/BIAResponsibility/' + biaResponsibilityId + '/Container';

                    return $http
                        .get(reqUrl)
                        .then(function (response) {
                            return mapLookupAttributeValues(response.data.BIAKeyPersons)
                                .then(function (mappedKeyPersons) {
                                    response.data.BIAKeyPersons = mappedKeyPersons;
                                    return response.data;
                                })
                                .then(function (container) {
                                    return mapLookupAttributeValues(container.BIAResponsibility);
                                })
                                .then(function (mappedResponsibility) {
                                    response.data.BIAResponsibility = mappedResponsibility;
                                    return response.data;
                                });
                        });
                },

                // Create BIA Responsibility
                createBIAResponsibility: function (biaProfileId, biaResponsibility) {
                    var reqUrl = baseUrl + '/' + biaProfileId + '/Responsibility';

                    return $http
                        .post(reqUrl, {
                          BIAProfileID: biaProfileId,
                          ... biaResponsibility
                        })
                        .then(function (response) {
                            return mapLookupAttributeValues(response.data);
                        });
                },

                // Update BIA Responsibility
                updateBIAResponsibility: function (biaProfileId, biaResponsibilityId, biaResponsibility) {
                    var reqUrl = baseUrl + '/' + biaProfileId + '/Responsibility/' + biaResponsibilityId;

                    return $http
                        .put(reqUrl, biaResponsibility)
                        .then(function (response) {
                            return mapLookupAttributeValues(response.data);
                        });
                },

                // Delete BIA Responsibility
                deleteBIAResponsibility: function (biaProfileId, biaResponsibilityId) {
                    var reqUrl = baseUrl + '/' + biaProfileId + '/BIAResponsibility/' + biaResponsibilityId;

                    return $http
                            .delete(reqUrl)
                            .then(function (response) {
                                return mapLookupAttributeValues(response.data);
                            });
                },

                // Get BIA Responsibility Computed Impact (0-100)
                getBIAResponsibilityComputedImpact: function (biaProfileId, biaResponsibilityId, biaResponsibility) {
                    var reqUrl = baseUrl + '/' + biaProfileId + '/Responsibility/' + biaResponsibilityId;

                    return $http
                        .post(reqUrl, biaResponsibility)
                        .then(function (response) { return response.data; });
                },

                // Get BIA Responsibility Computed Impact Level (Lookup Attribute Value)
                getBIAResponsibilityComputedImpactLevel: function (biaProfileId, biaResponsibility) {
                    var reqUrl = baseUrl + '/' + biaProfileId
                        + '/Responsibility/' + biaResponsibility.BIAResponsibilityID
                        + '/ComputedImpactLevel';

                    return $http
                        .post(reqUrl, biaResponsibility)
                        .then(function (response) { return response.data; });
                },

                // Get BIA Responsabilities by Profile
                getBIAResponsibilities: function (biaProfileId) {
                    var reqUrl = baseUrl + '/' + biaProfileId + '/BIAResponsibility';

                    return $http
                        .get(reqUrl)
                        .then(function (response) {
                            return mapLookupAttributeValues(response.data);
                        });
                },

                // Get BIA Responsabilities for BU Owner
                getBIAResponsibilitiesForBUOwner: function (biaProfileId, buOwnerId) {
                    var reqUrl = baseUrl + '/' + biaProfileId + '/BIAResponsibility/For/BUOwner/' + buOwnerId;

                    return $http
                        .get(reqUrl)
                        .then(function (response) {
                            return mapLookupAttributeValues(response.data);
                        });
                },

                // Get Available Systems by BIA Responsibility (role-linked)
                getBIAResponsibilitySystemsContainer: function (biaProfileId, biaResponsibilityId) {
                    var reqUrl = baseUrl + '/' + biaProfileId
                        + '/BIAResponsibility/' + biaResponsibilityId
                        + '/System/Container';

                    return $http
                        .get(reqUrl)
                        .then(function (response) {
                            return response.data;
                        });
                },

                // Get All Systems by BIA Responsibility (full registry)
                getBIAResponsibilityAllSystemsContainer: function (biaProfileId, biaResponsibilityId) {
                    var reqUrl = baseUrl + '/' + biaProfileId
                        + '/BIAResponsibility/' + biaResponsibilityId
                        + '/System/AllContainer';

                    return $http
                        .get(reqUrl)
                        .then(function (response) {
                            return response.data;
                        });
                },


                // Key Persons

                // Create Key Person
                createKeyPerson: function (biaProfileId, biaResponsibilityId, keyPerson) {
                    var reqUrl = baseUrl + '/' + biaProfileId + '/BIAResponsibility/' + biaResponsibilityId + '/BIAKeyPerson';
                    return $http
                        .post(reqUrl, keyPerson)
                        .then(function (response) {
                            return response.data;
                        });
                },

                // Get Key Person
                getKeyPerson: function (biaProfileId, biaResponsibilityId, keyPersonId) {
                    var reqUrl = baseUrl + '/' + biaProfileId
                        + '/BIAResponsibility/' + biaResponsibilityId
                        + '/BIAKeyPerson/' + keyPersonId;

                    return $http
                        .get(reqUrl)
                        .then(function (response) {
                            return response.data;
                        });
                },

                // Update Key Person
                updateKeyPerson: function (biaProfileId, biaResponsibilityId, keyPerson) {
                    var reqUrl = baseUrl + '/' + biaProfileId
                        + '/BIAResponsibility/' + biaResponsibilityId
                        + '/BIAKeyPerson/' + keyPerson.BIAKeyPersonID;

                    return $http
                        .put(reqUrl, keyPerson)
                        .then(function (response) {
                            return response.data;
                        });
                },

                // Delete Key Person
                deleteBIAKeyPerson: function (biaProfileId, biaResponsibilityId, biaKeyPersonId) {
                    var reqUrl = baseUrl + '/' + biaProfileId
                                         + '/BIAResponsibility/' + biaResponsibilityId
                                         + '/BIAKeyPerson/' + biaKeyPersonId;

                    return $http.delete(reqUrl)
                                .then(function (response) {
                                    return response.data;
                                });
                },

                // Get Remaining Responsibilities to rate
                getBIAResponsibilitiesForBUOwnerAndTaskDefinition: function (biaProfileId, biaBuOwner, taskDefinitionName) {

                    var reqUrl = baseUrl + '/' + biaProfileId
                        + '/BIAResponsibility/For/BIABUOwner/' + biaBuOwner
                        + '/For/Task/' + taskDefinitionName;

                    return $http
                        .get(reqUrl)
                        .then(function (response) {
                            return response.data;
                        });
                },
            };

            function mapLookupAttributeValues(model) {
                return bcmService
                    .getBCMLookups()
                    .then(function (container) {
                        var modelsToMap = _.isArray(model) ? model : [model];

                        _.map(modelsToMap, function (modelToMap) {

                            // Priority Level
                            if (!_.isUndefined(modelToMap.PriorityLevelID)) {
                                modelToMap.PriorityLevel = container.PriorityLevelsByID[modelToMap.PriorityLevelID];
                            }

                            // Offsite Execution
                            if (!_.isUndefined(modelToMap.OffSiteExecutionID)) {
                                modelToMap.OffSiteExecution = container.OffSiteExecutionsByID[modelToMap.OffSiteExecutionID];
                            }

                            // Operational Workaround
                            if (!_.isUndefined(modelToMap.OperationalWorkaroundID)) {
                                modelToMap.OperationalWorkaround =
                                    container.OperationalWorkaroundsByID[modelToMap.OperationalWorkaroundID];
                            }

                            // Key Person Roles
                            if (!_.isUndefined(modelToMap.RoleID)) {
                                modelToMap.Role = container.KeyPersonRolesByID[modelToMap.RoleID];
                            }

                        });

                        return model;
                    });
            }
        }]);
})();
